import { css } from 'aphrodite';
import * as React from 'react';
import { Checkbox } from '../../../../../web/components/Checkbox';
import { ConfirmationDialog, IConfirmationDialogOption } from '../../../../../web/components/ConfirmationDialog';
import { WarningIcon, WarningIconType } from '../../../../../web/components/svgs/icons/WarningIcon';
import { styleSheet } from './styles';

const ResetConfirmationOptions: IConfirmationDialogOption<boolean>[] = [
	{
		isDestructive: true,
		title: 'Reset Account',
	},
	{
		isCancel: true,
		isCta: true,
		title: 'Cancel',
	},
];

export interface IResetAccountModalProps {
	showAccountResetModal: boolean;
	onAccountResetModalRequestClose: (reset?: boolean, includeIntegration?: boolean, canceled?: boolean) => void;
	companyName?: string;
}

export const ResetAccountModal: React.FC<IResetAccountModalProps> = props => {
	const { showAccountResetModal, onAccountResetModalRequestClose, companyName } = props;

	const [includeIntegration, setIncludeIntegration] = React.useState<boolean>(false);
	const onIncludeIntegrationChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
		setIncludeIntegration(e.target.checked);
	};

	const onRequestClose = (result?: IConfirmationDialogOption<boolean>, canceled?: boolean) => {
		onAccountResetModalRequestClose?.(result?.isDestructive, includeIntegration, canceled);
	};

	return (
		<ConfirmationDialog
			className={css(styleSheet.resetAccountModal)}
			icon={<WarningIcon type={WarningIconType.Red} />}
			modalProps={{
				isOpen: showAccountResetModal,
				onRequestClose,
			}}
			options={ResetConfirmationOptions}
			title={
				<div>
					<div className={css(styleSheet.resetAccountModalHeaderText)}>Account Warning</div>
					<div className={css(styleSheet.resetAccountModalWarningText)}>
						You are about to reset this entire account.
					</div>
					{companyName && <div className={css(styleSheet.resetAccountModalCompanyName)}>Account: {companyName}</div>}
					<p className={css(styleSheet.resetAccountModalBodyText1)}>
						This will permanently clear the account of contacts, companies, tags, households, connection types, text
						messages, and donations.
					</p>
					<Checkbox
						id='nuke-integration-checkbox'
						onChange={onIncludeIntegrationChanged}
						checked={includeIntegration}
						className={css(styleSheet.includeIntegrationsCheckboxContainer)}
					>
						<span className={css(styleSheet.includeIntegrationsCheckbox)}>Delete all integration data.</span>
					</Checkbox>
					{includeIntegration ? (
						<p className={css(styleSheet.resetAccountModalWarningText2)}>
							All integration data and settings will be permanently deleted.
						</p>
					) : null}
					<div className={css(styleSheet.resetAccountModalBodyText2)}>Are you sure you wish to continue?</div>
				</div>
			}
		/>
	);
};
